import { render, staticRenderFns } from "./RecycoInput.vue?vue&type=template&id=08b1bf36&scoped=true&"
import script from "./RecycoInput.vue?vue&type=script&lang=js&"
export * from "./RecycoInput.vue?vue&type=script&lang=js&"
import style0 from "./RecycoInput.vue?vue&type=style&index=0&id=08b1bf36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b1bf36",
  null
  
)

export default component.exports